import './App.css';
import React, { useState, useEffect } from "react";
import { defineAbilitiesFor } from './ability';
import RouteWrapper from './RouterWrapper';
import { AbilityProvider } from './AbilityContext';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router';

function App() {
  const roleInfo = useSelector((state) => state?.user?.role);
  const selectedOrgData = useSelector((state) => state?.user?.selectedOrgData);
  const [ability, setAbility] = useState(null);
  const userRole = roleInfo?.role?.name;
  const orgStatus = selectedOrgData?.[0]?.app_status;

  useEffect(() => {
    if (!userRole) {
      return;
    }
    let userInfo = {
      role: userRole
    }
    if (orgStatus === 'inactive') {
      delete userInfo.role;
    }
    console.log('setting updated ability in appjs userInfo:::', userInfo);
    let ability = defineAbilitiesFor(userInfo);
    setAbility(ability);
  }, [userRole, selectedOrgData]);

  return (
    <AbilityProvider ability={ability}>
      <RouteWrapper />
    </AbilityProvider>
  )
}

export default App;